export default "__VITE_ASSET__BrQmBEUe__"